module.exports = __webpack_public_path__ + "assets/img/mecha-detail-btn-c2ccf37a.png";